// Local Imports
import { ROUTE_PATHS, ROUTE_NAMES } from '@/router/constants';

/*************************** SIDE MENU ROUTERS *****************************/
export const sideMenuRoutes = {
  creator: [
    {
      path: '#',
      text: 'Manage Media Kit',
      moduleName: ROUTE_NAMES.MEDIA_KIT,
      child: [
        {
          // path: ROUTE_PATHS.KIT_MANAGEMENT,
          moduleName: ROUTE_NAMES.EDIT_KIT,
          text: 'Edit Kit',
          parentModule: ROUTE_NAMES.MEDIA_KIT
        },
        {
          path: ROUTE_PATHS.SHAREABLE_LINK,
          moduleName: ROUTE_NAMES.SHAREABLE_LINK,
          parentModule: ROUTE_NAMES.MEDIA_KIT,
          text: 'Shareable Link'
        },
        {
          path: ROUTE_PATHS.AUTHENTICATE_SOCIAL,
          moduleName: ROUTE_NAMES.AUTHENTICATE_SOCIAL,
          text: 'Authenticate Socials',
          parentModule: ROUTE_NAMES.MEDIA_KIT
        },
        {
          path: ROUTE_PATHS.BRANDS_REVIEWS,
          moduleName: ROUTE_NAMES.BRANDS_REVIEWS,
          text: 'Brand Reviews',
          parentModule: ROUTE_NAMES.MEDIA_KIT
        },
      ]
    },
    {
      path: '#',
      text: 'Collab Center',
      moduleName: ROUTE_NAMES.COLLAB_CENTER,
      child: [
        {
          path: ROUTE_PATHS.GIFTED,
          moduleName: ROUTE_NAMES.GIFTED,
          parentModule: ROUTE_NAMES.COLLAB_CENTER,
          text: 'Gifted'
        },
        {
          path: ROUTE_PATHS.PAID,
          moduleName: ROUTE_NAMES.PAID,
          text: 'Paid',
          parentModule: ROUTE_NAMES.COLLAB_CENTER
        }
      ]
    },
    {
      path: '#',
      text: "Profile",
      moduleName: ROUTE_NAMES.USER_PROFILE,
      child: [
        {
          path: ROUTE_PATHS.PROFILE_ACCOUNT,
          moduleName: ROUTE_NAMES.PROFILE_ACCOUNT,
          parentModule: ROUTE_NAMES.USER_PROFILE,
          text: 'Profile & Account',
          planType: 'free'
        },
        {
          path: ROUTE_PATHS.UPGRADE_MEDIA_KIT,
          moduleName: ROUTE_NAMES.UPGRADE_MEDIA_KIT,
          text: 'Upgrade Media Kit',
          parentModule: ROUTE_NAMES.USER_PROFILE,
          planType: 'free'
        },
        {
          path: ROUTE_PATHS.MANAGE_SUBSCRIPTION,
          moduleName: ROUTE_NAMES.MANAGE_SUBSCRIPTION,
          text: 'Manage Subscription',
          parentModule: ROUTE_NAMES.USER_PROFILE,
          planType: 'paid'
        }
      ]
    }
  ],
  admin: [
    {
      path: '#',
      text: 'Admin',
      moduleName: ROUTE_NAMES.ADMIN_NAV,
      child: [
        {
          path: ROUTE_PATHS.ADMIN_DASHBOARD,
          moduleName: ROUTE_NAMES.ADMIN_DASHBOARD,
          parentModule: ROUTE_NAMES.ADMIN_NAV,
          text: 'Dashboard',
        },
        {
          path: ROUTE_PATHS.ADMIN_USERS,
          moduleName: ROUTE_NAMES.ADMIN_USERS,
          parentModule: ROUTE_NAMES.ADMIN_NAV,
          text: 'Users',
        },
      ],
    },
  ],
};
